import { createMockHttpClient } from '../../../../src/mocks';
const response = [
    {
        configurationId: '20d1e26c-ec0f-4373-8f4f-f8487be73472',
        title: 'Outlook',
        providerType: 'MsEntra',
        authenticationType: 'OAuth',
        baseApiUrl: 'https://graph.microsoft.com/v1.0',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    },
    {
        configurationId: 'e2dcecb4-d1ac-456c-864a-c3a12a82e662',
        title: 'orion basic',
        providerType: 'OrionBasic',
        authenticationType: 'OAuth',
        baseApiUrl: 'https://api.orionadvisor.com/api/v1',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    },
    {
        configurationId: 'ab5bb0e0-d0e3-4fc2-b559-a4dba7b77055',
        title: 'M-Files',
        providerType: 'MFiles',
        authenticationType: 'OAuth',
        baseApiUrl: '',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    },
    {
        configurationId: '8425bca8-c83a-4fca-9a7f-af5f4aa4f709',
        title: 'Salesforce',
        providerType: 'Salesforce',
        authenticationType: 'OAuth',
        baseApiUrl: 'https://invent7-dev-ed.develop.my.salesforce.com',
        baseDeepLinkUrl: null,
        userName: 'integration-team+shared@invent.us',
        isAuthorized: true
    },
    {
        configurationId: '39c6c697-1144-4e0e-81af-ac98fccad45b',
        title: 'Redtail (review.crm.redtailtechnology.com)',
        providerType: 'Redtail',
        authenticationType: 'Basic',
        baseApiUrl: 'https://review.crm.redtailtechnology.com/api/public/v1',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    },
    {
        configurationId: '0656a91e-bc9c-462a-ad0a-a0ac2c499a34',
        title: 'Wealthbox',
        providerType: 'Wealthbox',
        authenticationType: 'OAuth',
        baseApiUrl: 'https://api.crmworkspace.com',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: true
    },
    {
        configurationId: 'f08cf48d-e196-46a4-8b9a-117317d9dd60',
        title: 'M-files (instance 22)',
        providerType: 'MFiles',
        authenticationType: 'OAuth',
        baseApiUrl: '',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    },
    {
        configurationId: '12b155c9-ded4-42da-90c8-f89f6926f579',
        title: 'Redtail test',
        providerType: 'Redtail',
        authenticationType: 'Basic',
        baseApiUrl: '',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    },
    {
        configurationId: 'd28a6ca5-04c7-4c97-a6ad-e85b27cfd7f6',
        title: 'Hubspot 123456',
        providerType: 'HubSpot',
        authenticationType: 'OAuth',
        baseApiUrl: 'https://api.hubapi.com',
        baseDeepLinkUrl: null,
        userName: null,
        isAuthorized: false
    }
];
export const httpClientGetConfig = createMockHttpClient({
    value: response
});
export const httpClientGetLoginUrl = createMockHttpClient({
    data: {
        url: 'https://api.dev.icp.invent.us/v1/pea/public/login/?secret=CfDJ8CtbvSHFE6BFqanlMZuR6MzgIpyMZlHKKrs1DWuxY1dTTCoIKLQvoEYvGt6rpCZQFoXrzpne3vXavzXiTDXNyq8s14JTZ9v2Jic063cOZ10CJ3-5eaudmrW8uGweYG_E9bUJPZ3MMtpbF35A_r4_vevnu79l25RVZ05Q5DBHJMlBdJZEn6weHpFRJJsivbJ70b8A6hGWrYt4TlCzgglrdRNRUcBSV_yCPSu08ckDzX-kIe3TBG_OIHq2rXz35Yi28kZ-A7xsHQRiw3WnXUZOobbf5kcxlYVlL-eifU388mjFUtzJcoi5kktLtYP1l04vYfIm-dblYZPVsvUu7sQsz9uN_CVqHDuu849EKue6ILsm3p3wP9EvXTT6Lgg0hpJ-Cg'
    },
    value: { 'Content-Type': 'application/json' }
});
export const mockError = {
    message: 'Invalid Credentials',
    description: 'The username or password you entered is incorrect. Please check your credentials and try again.',
    action: () => {
        alert('Please check your credentials and try again.');
    }
};
export const mockHttpClientWithError = (httpStatus) => () => Promise.reject(new Error(JSON.stringify({ status: httpStatus })));
export const broadcastChannelMock = {
    name: 'auth_channel',
    onmessage: null,
    postMessage: () => {
        // no-op
    },
    close: () => {
        // no-op
    }
};
